import  domain  from "../domain";
import * as x2js from "xml2js";
import http from "./httpService";
import Axios from "axios";
// const CONF_URL = CONFIG.Settings;
const ticketKey = "ticketUser";
const loginKey = "loginUser";
let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=600,height=300,left=100,top=100`;

function redirect() {
  const redirectURL =
    domain.CASLOGIN + "service=" + encodeURIComponent(domain.MY_APLICATION);
  window.open(redirectURL, "_self");
}
export function verificaLogin() {
  if (!isAuthenticated()) {
    redirect();
  }
  return getTicketCAS();
}
export function isAuthenticated() {
  var rawIdToken = getTicket();
  return isNotEmpty(rawIdToken);
}

export function saveTicket() {
  let ticket = window.location.search.replace("?ticket=", "");
  // window.history.pushState("", "", "/");
  console.log(ticket)
  if (ticket !== null) {
    sessionStorage.setItem(ticketKey, ticket);
  }
}
async function getTicketCAS() {
  var service = encodeURIComponent(domain.MY_APLICATION);
  var ticket = getTicket();
  if (ticket === "") return;
  var urlvalidate =
    domain.VALIDATE_TICKET + "service=" + service + "&ticket=" + ticket;
  try {
    const res = await http.get(urlvalidate);
    console.log(res)
    console.log(validation(res))
    return validation(res);
  } catch (error) {
    console.log("error: ", error);
  }
}

function validation(res) {
  x2js.parseString(res.data, (err, resultado) => {
    let sucesso = resultado["cas:serviceResponse"]["cas:authenticationSuccess"];
    if (sucesso !== undefined) {
      var sucess =
        resultado["cas:serviceResponse"]["cas:authenticationSuccess"];
      let user = sucess[0]["cas:user"];
     console.log(user)
      // if (atributos[0]["cas:clientName"] !== undefined) {
      //   sessionStorage.setItem("clientName", atributos[0]["cas:clientName"]);
       
      // } else {
      //   sessionStorage.setItem("clientName", "Centralizada");
      // }
      sessionStorage.setItem(loginKey, user);
    } else {
      let error = resultado["cas:serviceResponse"]["cas:authenticationFailure"];
      console.log("Error: " + error);
      logout();
    }
    return;
  });
}

export function getTicket() {
  return sessionStorage.getItem(ticketKey);
}
export function getLogin() {
  return sessionStorage.getItem(loginKey);
}
function isNotEmpty(obj) {
  return !isEmpty(obj);
}
function isEmpty(obj) {
  return obj === undefined || obj == null || obj === "" || obj === " ";
}

export  function logout() {
 
  var logout = "";
  remove();
 
    logout =
      domain.CASLOGOUT +"service="+domain.LOGOUT_REDIRECT
   //   window.location.href='https://bhuvan-app1.nrsc.gov.in/bhuvan2d/bhuvan/loading.php?q=logout.php'     
  //downloadURL(logout)
  // let currentIndex = 0;
  // let files=[logout,domain.LOGOUT_REDIRECT]
  // const intervalId = setInterval(() => {
  //   if (currentIndex === files.length - 1) clearInterval(intervalId);
  //   window.location.href = files[currentIndex];
  //   currentIndex++;
  // }, 3000);
var win=window.open(logout,'Logout Page',params)
setTimeout(
  function(){
  win.close();
  window.location=domain.LOGOUT_REDIRECT
  }
  ,2000)
  
//window.location.href = CONF_URL.LOGOUT_REDIRECT;
}

function remove() {
    console.log(window.sessionStorage)
  window.sessionStorage.removeItem("ticketUser");
  window.sessionStorage.removeItem("loginUser");
  ///window.sessionStorage.removeItem("clientName");
}
export default {
  redirect,
  getLogin,
  saveTicket,
  getTicketCAS,
  verificaLogin,
  isAuthenticated,
  getTicket,
  logout,
};